import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { COLOR, FONT, THEME } from '../../../constants/styles';
import OPComponent from '../op_component';
import TextUtils from '../../../textUtils';

export default class FieldLabel extends OPComponent {
  render() {
    const { label, labelComp, required, readonly, style, noCaps, noAsteriskSpace, extraLabel } =
      this.props;
    const ast = noAsteriskSpace ? '*' : ' *';

    return (
      <Text style={[THEME.labelText, style]}>
        {labelComp}
        {noCaps ? label : TextUtils.ac(label)}
        {!!extraLabel && ` ${noCaps ? extraLabel : TextUtils.ac(extraLabel)}`}
        <Text style={styles.requiredAsteriskSmall}>{required && !readonly ? ast : ''}</Text>
      </Text>
    );
  }
}

const styles = StyleSheet.create({
  asteriskSpace: {
    fontSize: 6,
  },
  requiredAsteriskSmall: {
    color: COLOR.emphasis,
    paddingLeft: 2,
    fontSize: 14,
  },
});
